
import {dateFormat} from '~/plugins/formatting';
import ReviewsCommentAttachment from '~/components/catalog/reviews/Comment/Attachment';

export default {
  name: 'ReviewsComment',
  components: {ReviewsCommentAttachment},
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedDateTime() {
      return dateFormat(
        new Date(this.item.created_at),
        {
          month: 'long',
          day: '2-digit',
          year: 'numeric',
        },
        'ru-RU',
      );
    },
  },
}
